<template>
	<wt-selector :options="options" v-model="Value" :clearable="true"></wt-selector>
</template>
<script>
export default {
  name: 'lab-order-status-selector',
  props: {
    value: {
      type: String
    }
  },
  data () {
    return {
      Value: this.value ? this.value : '',
      options: []
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    getOptions () {
      let options = []
      this.$store.dispatch('getVendorType').then(data => {
        data.forEach(item => {
          let signalItem = {
            label: item.name,
            value: item.value
          }
          options.push(signalItem)
        })
        this.options = options
      })
    }
  },
  created () {
    this.getOptions()
  }
}
</script>
